import { useOrganization } from "@/api/services/admin/organization";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { InnerBox } from "@/modules/irohana-components/elements/InnerBox";
import { Grid } from "@mui/material";

export const OrganizationBasicInfo = () => {
  const { data } = useOrganization();
  const org = data?.data;

  return (
    <InnerBox title="基本情報" p={3} bordered>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ItemInfo label="組織名" value={org?.name} isShowDivider={false} />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
